module.exports = require("././ngStorage.js");


//////////////////
// WEBPACK FOOTER
// ngstorage (bower component)
// module id = 403
// module chunks = 1